"use client";

import { Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Impact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  return;
}